import React from "react";
import Utils from "Utils/utils";

const ContactSelectedCount = props => {
  const {
    pageType = "",
    selectedCount = 0,
    totalCount = 0,
    totalCountDisplay,
    loading = false,
    allContactSelected = false,
    enableSelectAll = true,
    setAllContactSelected = () => {},
    resetCbk = () => {},
    selectAllCbk = () => {},
    selectedType = "Contact"
  } = props || {};

  const changeAction = (value = false) => {
    setAllContactSelected(value);
    value
      ? !["task"]?.includes(pageType?.toLowerCase()) && selectAllCbk(true)
      : resetCbk();
  };

  return (
    <div className="contactSelectedCount">
      {(!loading && (
        <>
          {allContactSelected ? (
            <div className="allContactSelected">
              {`All ${selectedType}s selected.`}
              <span
                onClick={() => changeAction(false, true)}
                className="clearBtn"
              >
                Clear selection
              </span>
            </div>
          ) : (
            <>
              <span className="selectedCount">
                {Utils.formatNumberToString(selectedCount)} selected
              </span>
              {enableSelectAll && (
                <span className="totalCount" onClick={() => changeAction(true)}>
                  Select all {totalCountDisplay != null ? totalCountDisplay : Utils.formatNumberToString(totalCount)}{" "}
                  {selectedType}
                  {Utils.isPlural(totalCount)} in this view.
                </span>
              )}
              {["discover"].includes(pageType?.toLowerCase()) && (
                <span onClick={() => changeAction(false)} className="clearBtn">
                  Clear selection
                </span>
              )}
            </>
          )}
        </>
      )) ||
        ""}
    </div>
  );
};

export default ContactSelectedCount;
export { ContactSelectedCount };
